import { makeStyles } from '@mui/styles';
import classNames from 'classnames';
import React from 'react';

import ControlChangesIcon from './ControlChangesIcon';
import { useFormSelector } from '../../custom-hooks';
import { SS_CONTROL_TYPE } from '../constants/form-manager.constants';
import { FCM_BORDER_STYLES, FCM_HIDDEN_CONTROL_STYLES } from '../constants/runtime.constants';
import { getIsFormChangesMode } from '../selectors/common.selectors';

const useStyles = makeStyles({
  changesModeWrapper: {
    display: 'flex',
    maxWidth: 618,
    margin: '8px 0',
    padding: '4px 8px !important',
    border: FCM_BORDER_STYLES.CONDITIONAL,
  },
  control: {
    flexGrow: 1,
  },
  hiddenControl: FCM_HIDDEN_CONTROL_STYLES,
  changesIcon: {
    paddingLeft: 8,
  },
  textBoxFlex: {
    flex: '1 1 0',
  },
});

const FormInputChangesWrapper = ({
  children,
  id,
  isControlHiddenFCM,
  isControlAddedFCM,
  isControlChangedFCM,
}) => {
  const classes = useStyles({ isControlAddedFCM });
  const isFormChangesMode = useFormSelector(getIsFormChangesMode);

  const {
    controlType,
    parentType,
    isEditor,
    textBoxPropsJson = '{}',
  } = children.props.children.props;

  const isTextBoxInsideADV =
    parentType === SS_CONTROL_TYPE.ADVANCED_TEXT_BOX && controlType === SS_CONTROL_TYPE.TEXT_BOX;

  const isTextViewHidden =
    !isEditor &&
    controlType === SS_CONTROL_TYPE.TEXT_VIEW &&
    JSON.parse(textBoxPropsJson).isTextBoxHidden;

  const isHidden = isControlHiddenFCM || (isTextViewHidden && isFormChangesMode);

  if (isControlAddedFCM || isControlChangedFCM) {
    return (
      <div
        className={classNames(
          classes.changesModeWrapper,
          isTextBoxInsideADV ? classes.textBoxFlex : ''
        )}
        data-ss-id={id}
      >
        <div
          className={classNames(classes.control, isHidden ? classes.hiddenControl : '')}
          data-hidden-fcm={isHidden}
        >
          {children}
        </div>
        {isControlChangedFCM && (
          <div className={classes.changesIcon}>
            <ControlChangesIcon id={id} />
          </div>
        )}
      </div>
    );
  }

  if (isHidden && !isTextBoxInsideADV) {
    return (
      <div className={classes.hiddenControl} data-hidden-fcm="true">
        {children}
      </div>
    );
  }

  return children;
};

export default FormInputChangesWrapper;
